import React from "react";
import styled from "styled-components";
import Tooltip from "../tooltip/Tooltip";

const EditButton = ({tooltipDirection ='bottom', setUpdate, data, customBehavior}) => {

    const init = () => {
        if (customBehavior) {
            customBehavior()
        }
        else{
            if (typeof data === "boolean") {
                setUpdate(!data)
            } else if (Number.isInteger(data) || typeof data === "string") {
                setUpdate(data)
            }
        }
    }
    return (
        <Tooltip direction={tooltipDirection} content={"Modifier"}>
            <Button className={"edit-btn"} id={"edit-btn"} >
                <svg id={"edit-btn"} onClick={init} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                     fill="#3394F6">
                    <path id={"edit-btn"}  d="M0 0h24v24H0V0z" fill="none"/>
                    <path id={"edit-btn"}
                            d="M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                </svg>
            </Button>
        </Tooltip>

    )
}



const Button = styled.button`
  border: none;
  padding: 0.2em;
  cursor: pointer;
  background: transparent;
  border-radius: 50%;
  height: 36px;
  width: 36px;

  &:hover {
    background: var(--color-blue-06);

    svg {
      fill: var(--color-white);
    }
  }
`
export default EditButton;